var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMhcImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.852,
    height: 51.847,
    viewBox: "0 0 48.852 51.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18525",
    "data-name": "Group 18525",
    transform: "translate(-298.759 -1065.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18524",
    "data-name": "Group 18524",
    transform: "translate(237.759 139.243)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6499",
    "data-name": "Rectangle 6499",
    width: 30.241,
    height: 18.61,
    transform: "translate(78.447 947.657)",
    fill: "#f37b89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16901",
    "data-name": "Group 16901",
    transform: "translate(61 925.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_pdf",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M46.337,42.457H38.366V40.463h7.971a1,1,0,0,0,.995-.995V24.507a1,1,0,0,0-.995-.994H38.366V21.519h7.971a2.991,2.991,0,0,1,2.986,2.989V39.468A2.991,2.991,0,0,1,46.337,42.457ZM37.77,23.521h-.615a2.37,2.37,0,0,0-.823.149v-.157H19.439a1,1,0,0,0-.995.994V39.468a1,1,0,0,0,.995.995H36.332v-.175a2.363,2.363,0,0,0,.823.15h.615a2.375,2.375,0,0,0,.6-.078v.1h-.042V48.7a3.992,3.992,0,0,1-3.991,3.985H4.463A3.994,3.994,0,0,1,.472,48.7V4.833A4,4,0,0,1,4.463.839H24.131a1,1,0,0,1,.718.305l13.2,13.725a1,1,0,0,1,.279.691v7.952h.042V23.6A2.375,2.375,0,0,0,37.77,23.521ZM24.378,3.531V14.8H35.211ZM36.332,16.792H23.383a1,1,0,0,1-1-1V2.833H4.463a2,2,0,0,0-2,2V48.7a2,2,0,0,0,2,1.993H34.332a2,2,0,0,0,2-1.991V42.457H19.439a2.991,2.991,0,0,1-2.986-2.989V24.507a2.991,2.991,0,0,1,2.986-2.989H36.332V16.792Z",
    transform: "translate(-0.472 -0.839)",
    fill: "#6f7e8e",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "JPG",
    transform: "translate(318 1101)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 13,
    fontFamily: "Gotham-Bold",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "JPG")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhcImage);
export default __webpack_public_path__ + "static/media/mhc-Image.4a53099676d75a77e5c941b37e80fd72.svg";
export { ForwardRef as ReactComponent };